import { Route, Routes } from 'react-router-dom';

import Nav from './routes/nav.route';
import Home from './routes/home.route';
import Projects from './routes/projects.route';
import Blog from './routes/blog.route';
import About from './routes/about.route';
import Contact from './routes/contact.route';
import BlogPage from './routes/blogpage.route';

import { useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';

import './app.scss'

const Wrapper = ({children}) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
} 

function App() {
  return (
    <Wrapper>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/" element={<Nav />}>
          <Route path='blog' element={ <Blog /> }/>
          <Route path="blog/:blogId" element={<BlogPage />} />
          {/* <Route path='projects' element={<Projects />}/> */}
          <Route path='about' element={ <About /> }/>
          {/* <Route path='resume' />  */}
          <Route path='contact' element={<Contact />}/>   
        </Route>
      </Routes>
    </Wrapper>
  );
}

export default App;
